import { render, staticRenderFns } from "./SRCompanion.vue?vue&type=template&id=acf53d22&scoped=true"
import script from "./SRCompanion.vue?vue&type=script&setup=true&lang=ts"
export * from "./SRCompanion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SRCompanion.vue?vue&type=style&index=0&id=acf53d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf53d22",
  null
  
)

export default component.exports